import { formatTime } from '../../components/helpers.js'
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'
import CardPropertyDepartureReport from '../../components/Card/CardPropertyDepartureReport.vue'

const vehicleProvisionTableColumns = [
  {
    name: 'name',
    label: 'Название',
    align: 'left',
    field: row => row,
    sortable: true,
    columnFormat: 'object',
    columnObjectType: 'vehicleProvision'
  },
  {
    name: 'vehicle',
    label: 'ТС',
    align: 'left',
    field: row => row.vehicle ? row.vehicle.gosNumber : '',
    sortable: false
  },
  {
    name: 'serviceTimeAgreed',
    label: 'Согласованное время подачи ТС',
    labelTable: 'Согласованное время<br/>подачи ТС',
    align: 'left',
    field: row => row.serviceTimeAgreed,
    sortable: true,
    format: formatTime
  },
  {
    name: 'serviceEndTimeRequired',
    label: 'Плановое время сдачи ТС',
    labelTable: 'Плановое время<br/>сдачи ТС',
    align: 'left',
    field: row => row.serviceEndTimeRequired,
    sortable: true,
    format: formatTime
  }
]

function getPropertyConfig (code, eventId, objectConfig) {
  const key = eventId ? code + '_' + eventId : code
  return objectConfig.props.find(prop => prop.key === key)
}

function getDefaultCurrentAddress (vehicleProvision) {
  return vehicleProvision.report.relocationAddress || vehicleProvision.report.address || null
}

function updateVehicleOdometerAcceptanceProperties (eventId, formConfig, object) {
  // const formConfig = this // this._config
  const formProps = formConfig.props.filter(prop => prop.eventId === eventId)
  const vehicleProvision = formProps[0].componentProps._record // this._record
  const request = vehicleProvision.request

  if (!request.vehicleGroupProvision) {
    let closeRequest = false
    const closeRequestConfig = getPropertyConfig('closeRequest', eventId, formConfig)
    if (closeRequestConfig) {
      closeRequest = object[closeRequestConfig.key]
    }

    const vehicleOdometerFaultyConfig = getPropertyConfig('vehicleOdometerFaulty', eventId, formConfig)
    const vehicleOdometerValueConfig = getPropertyConfig('vehicleOdometerValue', eventId, formConfig)
    if (vehicleOdometerFaultyConfig && vehicleOdometerValueConfig && (vehicleOdometerFaultyConfig.editable || vehicleOdometerValueConfig.editable)) {
      const vehicleOdometerFaulty = !!object[vehicleOdometerFaultyConfig.key]

      const vehicleOdometerValueRequiredAndEditable = !vehicleOdometerFaulty && !closeRequest
      vehicleOdometerValueConfig.required = vehicleOdometerValueRequiredAndEditable
      vehicleOdometerValueConfig.readonly = !vehicleOdometerValueRequiredAndEditable
      vehicleOdometerValueConfig.editable = vehicleOdometerValueRequiredAndEditable

      if (vehicleOdometerFaultyConfig.editable && vehicleOdometerFaulty) {
        object[vehicleOdometerValueConfig.key] = null
      }
    }
  }
}

export const EVENTS_PROPERTIES = {
  vehicleReplacingRequestBinding: () => ({
    request: {
      type: 'object',
      subType: 'vehicleProvision',
      label: 'Заявка',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        select: true,
        dialogLabel: 'Выбор заявки',
        fullReadable: false,
        searchable: false,
        cached: false,
        optionAdditionalInfoFn: vehicleProvision => {
          return vehicleProvision.vehicle ? vehicleProvision.vehicle.gosNumber : null
        },
        proxy: {
          urlBase: '/service/delta/vehicleProvision/searchReplacement',
          get urlParams () {
            return {
              request: this._record.request.id,
              replacing: true
            }
          },
          filterType: 'vehicleProvisionRequest',
          formId: 'searchReplacement',
          mapper: vehicleProvision => vehicleProvision.request
        },
        dialogColumns: vehicleProvisionTableColumns
      }
    }
  }),
  vehicleReplacementRequestBinding: () => ({
    request: {
      type: 'object',
      subType: 'vehicleProvision',
      label: 'Заявка',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        select: true,
        dialogLabel: 'Выбор заявки',
        fullReadable: false,
        searchable: false,
        cached: false,
        optionAdditionalInfoFn: vehicleProvision => {
          return vehicleProvision.vehicle ? vehicleProvision.vehicle.gosNumber : null
        },
        proxy: {
          urlBase: '/service/delta/vehicleProvision/searchReplacement',
          get urlParams () {
            return {
              request: this._record.request.id,
              replacing: false
            }
          },
          filterType: 'vehicleProvisionRequest',
          formId: 'searchReplacement',
          mapper: vehicleProvision => vehicleProvision.request
        },
        dialogColumns: vehicleProvisionTableColumns
      }
    }
  }),
  reason: () => ({
    reason: {
      type: 'string',
      label: 'Причина'
    }
  }),
  ready: () => ({
    serviceTimeAgreed: {
      type: 'datetime',
      label: 'Согласованное время подачи ТС',
      getDefaultValueFn: function () {
        const request = this._record.request
        if (request.serviceTimeAgreed) {
          return request.serviceTimeAgreed
        } else if (request.serviceTimeRequired) {
          return request.serviceTimeRequired
        } else {
          return null
        }
      }
    }
  }),
  deliveryParametersChange: () => ({
    address: {
      type: 'address',
      label: 'Адрес подачи ТС',
      getDefaultValueFn: function () {
        const request = this._record.request
        return JSON.parse(JSON.stringify(request.address)) || null
      }
    },
    previousAddress: {
      type: 'address',
      label: 'Адрес подачи ТС (предыдущее значение)'
    },
    time: {
      type: 'datetime',
      label: 'Время подачи ТС',
      getDefaultValueFn: function () {
        const request = this._record.request
        if (request.serviceTimeAgreed) {
          return request.serviceTimeAgreed
        } else if (request.serviceTimeRequired) {
          return request.serviceTimeRequired
        } else {
          return null
        }
      }
    },
    previousTime: {
      type: 'datetime',
      label: 'Время подачи ТС (предыдущее значение)'
    }
  }),
  driverChange: () => ({
    driver: {
      type: 'object',
      label: 'Водитель',
      subType: 'employee',
      subSubType: 'forkLiftDriver',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор водителя',
        getURL: function () {
          return getDriverURL(this._record.request)
        },
        select: true,
        cached: false
      }
    },
    previousDriver: {
      type: 'object',
      label: 'Водитель (предыдущее значение)',
      subType: 'employee',
      subSubType: 'forkLiftDriver',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор водителя',
        getURL: function () {
          return getDriverURL(this._record.request)
        },
        select: true,
        cached: false
      }
    }
  }),
  vehicleChange: () => ({
    vehicle: {
      type: 'object',
      subType: 'vehicle',
      subSubType: 'vehicleProvided',
      label: 'Предоставляемое ТС',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор ТС',
        getURL: function () {
          return getVehiclesURL(this._record.request)
        },
        select: true,
        cached: false
      }
    },
    previousVehicle: {
      type: 'object',
      subType: 'vehicle',
      subSubType: 'vehicleProvided',
      label: 'Предоставляемое ТС (предыдущее значение)',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор ТС',
        getURL: function () {
          return getVehiclesURL(this._record.request)
        },
        select: true,
        cached: false
      }
    }
  }),
  readyResult: () => ({
    address: {
      type: 'address',
      label: 'Адрес подачи ТС'
    },
    serviceTimeAgreed: {
      type: 'datetime',
      label: 'Согласованное время подачи ТС'
    },
    serviceType: {
      type: 'listvalue',
      label: 'Тип услуги',
      listvalues: [
        { value: 'for24h', name: 'ТС предоставляется на 24ч' },
        { value: 'byTheTime', name: 'ТС предоставляется повременно' }
      ]
    },
    vehicle: {
      type: 'object',
      subType: 'vehicle',
      subSubType: 'vehicleProvided',
      label: 'Согласованное ТС',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор ТС',
        getURL: function () {
          return getVehiclesURL(this._record.request)
        },
        select: true,
        cached: false
      }
    },
    driver: {
      type: 'object',
      label: 'Водитель',
      subType: 'employee',
      subSubType: 'forkLiftDriver',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор водителя',
        getURL: function () {
          return getDriverURL(this._record.request)
        },
        select: true,
        cached: false
      },
      getDefaultValueFn: function () {
        return this._record.request.driver || null
      }
    }
  }),
  acceptance: () => ({
    vehicle: {
      type: 'object',
      label: 'Прибывшее ТС',
      subType: 'vehicle',
      subSubType: 'vehicleProvided',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор ТС',
        getURL: function () {
          return getVehiclesURL(this._record.request)
        },
        select: true,
        cached: false
      },
      getDefaultValueFn: function () {
        return this._record.request.vehicle || null
      }
    },
    driver: {
      type: 'object',
      label: 'Прибывший водитель',
      subType: 'employee',
      subSubType: 'forkLiftDriver',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор водителя',
        getURL: function () {
          return getDriverURL(this._record.request)
        },
        select: true,
        cached: false
      },
      getDefaultValueFn: function () {
        return this._record.request.driver || null
      }
    },
    time: {
      type: 'datetime',
      label: 'Время подачи ТС (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    currentAddressType: {
      type: 'listvalue',
      label: 'Адрес подачи ТС (фактический тип)',
      listvalues: [
        { value: 'agreed', name: 'Согласованный адрес' },
        { value: 'activeRequest', name: 'Активная заявка' },
        { value: 'other', name: 'Другой' }
      ]
    },
    currentAddress: {
      type: 'address',
      label: 'Адрес подачи ТС (фактический)'
    },
    departureInfo: {
      name: 'Отчёт о выполнении работ',
      type: 'object',
      computed: true,
      component: CardPropertyDepartureReport
    },
    vehicleOdometerValue: {
      type: 'double',
      label: 'Показания одометра'
    },
    vehicleOdometerFaulty: {
      label: 'Одометр неисправен',
      type: 'boolean',
      onPropertyInput: function (value, object) {
        this._config.updateProperties(object)
      }
    },
    vehicleOdometer: {
      name: 'Фото одометра',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehicleOdometer',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    waybillDocuments: {
      name: 'Фото путевого листа',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'waybillDocuments',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    vehiclePerspective: {
      name: 'Фото ТС',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehiclePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    fencePerspective: {
      name: 'Фото выгородки',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'fencePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    unusableOnAcceptance: {
      type: 'boolean',
      label: 'ТС было непригодно при приемке',
      getDefaultValueFn: function () {
        return false
      }
    },
    closeRequest: {
      type: 'boolean',
      label: 'Закрыть заявку',
      getDefaultValueFn: function () {
        return false
      }
    },
    updateProperties (object) {
      const eventId = 'acceptance'
      updateVehicleOdometerAcceptanceProperties(eventId, this, object)

      const departureInfoConfig = getPropertyConfig('departureInfo', eventId, this)
      if (departureInfoConfig) {
        const departureInfo = object[departureInfoConfig.key]
        if (!departureInfo) {
          for (const prop of this.props) {
            if (prop.eventId === eventId && prop.code === 'departureInfo') {
              prop._hidden = true
            }
          }
        }
      }
    }
  }),
  locationResolution: () => ({
    currentAddressType: {
      type: 'listvalue',
      label: 'Адрес подачи ТС (фактический тип)',
      listvalues: [
        { value: 'agreed', name: 'Согласованный адрес' },
        { value: 'activeRequest', name: 'Активная заявка' },
        { value: 'other', name: 'Другой' }
      ],
      onPropertyInput: function (value, object) {
        this._config.updateProperties(object)
      }
    },
    currentAddress: {
      type: 'address',
      label: 'Адрес подачи ТС (фактический)'
    },
    activeRequestIsAgreed: {
      type: 'boolean',
      label: 'Активная заявка является согласованным адресом'
    },
    relocateOnActiveRequest: {
      type: 'boolean',
      label: 'Передислоцировать на активную заявку'
    },
    relocationAddress: {
      type: 'address',
      label: 'Адрес передислокации'
    },
    updateProperties (object) {
      const eventId = 'locationResolution' // this.eventId
      const formConfig = this // this._config
      const formProps = formConfig.props.filter(prop => prop.eventId === eventId)
      const vehicleProvision = formProps[0].componentProps._record // this._record
      const request = vehicleProvision.request

      const currentAddressTypeConfig = getPropertyConfig('currentAddressType', eventId, formConfig)
      const currentAddressConfig = getPropertyConfig('currentAddress', eventId, formConfig)
      const relocateOnActiveRequestConfig = getPropertyConfig('relocateOnActiveRequest', eventId, formConfig)
      const relocationAddressConfig = getPropertyConfig('relocationAddress', eventId, formConfig)
      const activeRequestIsAgreedConfig = getPropertyConfig('activeRequestIsAgreed', eventId, formConfig)

      const agreedAddress = JSON.parse(JSON.stringify(request.address)) || null
      const activeRequestAddress = object[relocationAddressConfig.key] || null
      const activeRequestIsAgreed = object[activeRequestIsAgreedConfig.key] || false
      const hasActiveRequestAddress = !!activeRequestAddress && activeRequestAddress.value != null

      const currentAddressType = object[currentAddressTypeConfig.key]
      const currentAddressTypeKey = currentAddressType != null ? currentAddressType.id || currentAddressType : null // value
      const currentAddressReadonly = currentAddressTypeKey === 'agreed' || currentAddressTypeKey === 'activeRequest'
      currentAddressConfig.readonly = currentAddressReadonly
      currentAddressConfig.editable = !currentAddressReadonly

      let relocateOnActiveRequestReadonly = !hasActiveRequestAddress || currentAddressTypeKey === 'agreed' && activeRequestIsAgreed
      if (!hasActiveRequestAddress) {
        currentAddressTypeConfig.listvalues = currentAddressTypeConfig.listvalues.filter(listvalue => listvalue.value != 'activeRequest')
      }

      if (currentAddressTypeKey === 'agreed') {
        object[currentAddressConfig.key] = agreedAddress

        if (!relocateOnActiveRequestReadonly) {
          object[relocateOnActiveRequestConfig.key] = true
        }
      } else if (currentAddressTypeKey === 'activeRequest') {
        object[currentAddressConfig.key] = activeRequestAddress && JSON.parse(JSON.stringify(activeRequestAddress)) || null

        object[relocateOnActiveRequestConfig.key] = false
        relocateOnActiveRequestReadonly = true
      } else {
        object[currentAddressConfig.key] = {
          id: null,
          name: null,
          value: null,
          type: null,
          region: null
        }
      }

      relocateOnActiveRequestConfig.readonly = relocateOnActiveRequestReadonly
      relocateOnActiveRequestConfig.editable = !relocateOnActiveRequestReadonly

      for (const prop of formProps) {
        if (prop.code === 'relocateOnActiveRequest' || prop.code === 'relocationAddress') {
          prop._hidden = relocateOnActiveRequestReadonly
        }
        //  else if (prop.code === 'activeRequestIsAgreed') {
        //   prop._hidden = true
        // }
      }
    }
  }),
  relocationStart: () => ({
    relocationAddress: {
      type: 'address',
      label: 'Адрес передислокации'
    },
    currentAddress: {
      type: 'address',
      label: 'Текущий адрес',
      getDefaultValueFn: function () {
        return getDefaultCurrentAddress(this._record)
      }
    },
    time: {
      type: 'datetime',
      label: 'Время начала передислокации (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    plannedArrivalTime: {
      type: 'datetime',
      label: 'Плановое время подачи ТС'
    }
  }),
  relocationEnd: () => ({
    time: {
      type: 'datetime',
      label: 'Время подачи ТС (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    currentAddress: {
      type: 'address',
      label: 'Адрес подачи ТС',
      getDefaultValueFn: function () {
        return this._record.report.relocationAddress || null
      }
    },
    departureInfo: {
      name: 'Отчёт о выполнении работ',
      type: 'object',
      computed: true,
      component: CardPropertyDepartureReport
    },
    fencePerspective: {
      name: 'Фото выгородки',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'fencePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    plannedDepartureTime: {
      type: 'datetime',
      label: 'Плановое время отбытия'
    },
    relocationAddress: {
      type: 'address',
      label: 'Ожидаемый адрес передислокации',
      computed: true
    },
    initialAddress: {
      type: 'address',
      label: 'Исходный адрес ТС',
      computed: true
    },
    updateProperties (object) {
      const eventId = 'relocationEnd'

      const departureInfoConfig = getPropertyConfig('departureInfo', eventId, this)
      if (departureInfoConfig) {
        const departureInfo = object[departureInfoConfig.key]
        if (!departureInfo) {
          for (const prop of this.props) {
            if (prop.eventId === eventId && prop.code === 'departureInfo') {
              prop._hidden = true
            }
          }
        }
      }
    }
  }),
  relocationCancel: () => ({
    currentAddress: {
      type: 'address',
      label: 'Текущий адрес',
      getDefaultValueFn: function () {
        return this._record.report.address || null // Исходный адрес
      }
    },
    relocationAddress: {
      type: 'address',
      label: 'Ожидаемый адрес передислокации',
      computed: true
    }
  }),
  notUsed: () => ({
    currentAddress: {
      type: 'address',
      label: 'Текущий адрес',
      getDefaultValueFn: function () {
        return getDefaultCurrentAddress(this._record)
      }
    }
  }),
  useResumed: () => ({
    currentAddress: {
      type: 'address',
      label: 'Текущий адрес',
      getDefaultValueFn: function () {
        return getDefaultCurrentAddress(this._record)
      }
    }
  }),
  closure: () => ({
    unusableOnAcceptance: {
      type: 'boolean',
      label: 'ТС было непригодно при приемке',
      getDefaultValueFn: function () {
        return false
      }
    },
    currentAddress: {
      type: 'address',
      label: 'Текущий адрес',
      getDefaultValueFn: function () {
        return getDefaultCurrentAddress(this._record)
      }
    },
    time: {
      type: 'datetime',
      label: 'Время завершения работ (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    vehicleOdometerValue: {
      type: 'double',
      label: 'Показания одометра',
      onPropertyInput: function (value, object) {
        this._config.updateProperties(object)
      },
      additionalValidateFn: function (value) {
        const request = this.componentProps._record.request
        if (!request.vehicleOdometerFaulty) {
          const startVehicleOdometerValue = request.startVehicleOdometerValue
          return value > startVehicleOdometerValue
        }
        return true
      }
    },
    vehicleOdometerDistance: {
      type: 'double',
      label: 'Пробег'
    },
    vehicleOdometer: {
      name: 'Фото одометра',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehicleOdometer',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    waybillDocuments: {
      name: 'Фото путевого листа',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'waybillDocuments',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    vehiclePerspective: {
      name: 'Фото ТС',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehiclePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    workShiftJournal: {
      name: 'Журнал смены',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'workShiftJournal',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    objectReadinessAct: {
      name: 'Акт готовности объекта',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'objectReadinessAct',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    updateProperties (object) {
      const eventId = 'closure'

      const vehicleOdometerDistanceConfig = getPropertyConfig('vehicleOdometerDistance', eventId, this)
      const vehicleOdometerValueConfig = getPropertyConfig('vehicleOdometerValue', eventId, this)
      if (vehicleOdometerDistanceConfig && vehicleOdometerValueConfig && (vehicleOdometerDistanceConfig.editable || vehicleOdometerValueConfig.editable)) {
        const request = vehicleOdometerDistanceConfig.componentProps._record.request
        const startVehicleOdometerValue = request.startVehicleOdometerValue // в заявке
        const endVehicleOdometerValue = object[vehicleOdometerValueConfig.key] // в событии

        const vehicleOdometerFaulty = request.vehicleOdometerFaulty
        if (vehicleOdometerFaulty) {
          vehicleOdometerValueConfig.readonly = true
          vehicleOdometerValueConfig.editable = false
        }

        vehicleOdometerDistanceConfig.editable = !startVehicleOdometerValue && !endVehicleOdometerValue && vehicleOdometerFaulty
        if (startVehicleOdometerValue != null && endVehicleOdometerValue != null && endVehicleOdometerValue > startVehicleOdometerValue) {
          object[vehicleOdometerDistanceConfig.key] = endVehicleOdometerValue - startVehicleOdometerValue
        } else if (endVehicleOdometerValue != null) {
          object[vehicleOdometerDistanceConfig.key] = null
        }
      }
    }
  }),
  reopen: () => ({
    time: {
      type: 'datetime',
      label: 'Время повторного открытия заявки (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    unusableOnAcceptance: {
      type: 'boolean',
      label: 'ТС было непригодно при приемке',
      getDefaultValueFn: function () {
        return false
      }
    },
    vehicleOdometerValue: {
      type: 'double',
      label: 'Показания одометра'
    },
    vehicleOdometerFaulty: {
      label: 'Одометр неисправен',
      type: 'boolean',
      onPropertyInput: function (value, object) {
        this._config.updateProperties(object)
      }
    },
    vehicleOdometer: {
      name: 'Фото одометра',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehicleOdometer',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    waybillDocuments: {
      name: 'Фото путевого листа',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'waybillDocuments',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    vehiclePerspective: {
      name: 'Фото ТС',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehiclePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    fencePerspective: {
      name: 'Фото выгородки',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'fencePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    updateProperties (object) {
      const eventId = 'reopen'
      updateVehicleOdometerAcceptanceProperties(eventId, this, object)
    }
  }),
  accident: () => ({
    duringRelocation: {
      type: 'boolean',
      label: 'Произошло при передислокации',
      getDefaultValueFn: function () {
        return this._record.bp.state === 'VP8'
      },
      onPropertyInput: function (value, object) {
        const addressConfig = getPropertyConfig('address', this.eventId, this._config)
        if (addressConfig) {
          addressConfig.required = !value
        }
        const photoConfig = getPropertyConfig('photo', this.eventId, this._config)
        if (photoConfig) {
          photoConfig.required = !value
        }
      }
    },
    address: {
      type: 'address',
      label: 'Адрес ДТП'
    },
    time: {
      type: 'datetime',
      label: 'Время ДТП (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    photo: {
      name: 'Фотографии ДТП',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'photo',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    }
  }),
  breakStart: () => ({
    currentAddress: {
      type: 'address',
      label: 'Текущий адрес',
      getDefaultValueFn: function () {
        return getDefaultCurrentAddress(this._record)
      }
    },
    time: {
      type: 'datetime',
      label: 'Время начала перерыва (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    reasonType: {
      type: 'listvalue',
      label: 'Причина',
      listvalues: [
        { value: 'lunch', name: 'Обеденный перерыв' },
        { value: 'vehicleMalfunction', name: 'Неисправность ТС' },
        { value: 'vehicleFueling', name: 'Заправка ТС' },
        { value: 'vehicleMaintenance', name: 'Обслуживание ТС' },
        { value: 'other', name: 'Прочее' }
      ],
      onPropertyInput: function (value, object) {
        const reasonDescriptionConfig = getPropertyConfig('reasonDescription', this.eventId, this._config)
        if (reasonDescriptionConfig) {
          reasonDescriptionConfig.required = value === 'other'
        }
      }
    },
    reasonDescription: {
      type: 'string',
      label: 'Описание причины'
    }
  }),
  breakEnd: () => ({
    startTime: {
      type: 'datetime',
      label: 'Время начала перерыва (фактическое)',
      computed: true
    },
    time: {
      type: 'datetime',
      label: 'Время завершения перерыва (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    duration: {
      type: 'string',
      label: 'Продолжительность перерыва',
      computed: true
    },
    reasonType: {
      type: 'listvalue',
      label: 'Причина',
      listvalues: [
        { value: 'lunch', name: 'Обеденный перерыв' },
        { value: 'vehicleMalfunction', name: 'Неисправность ТС' },
        { value: 'vehicleFueling', name: 'Заправка ТС' },
        { value: 'vehicleMaintenance', name: 'Обслуживание ТС' },
        { value: 'other', name: 'Прочее' }
      ],
      computed: true
    }
  }),
  reportVerified: () => ({
    qualitySatisfactory: {
      type: 'boolean',
      label: 'Качество услуги соответствует договору',
      getDefaultValueFn: function () {
        return true
      },
      onPropertyInput: function (value, object) {
        const qualityCommentConfig = getPropertyConfig('qualityComment', this.eventId, this._config)
        if (qualityCommentConfig) {
          qualityCommentConfig.required = !value
        }
      }
    },
    qualityComment: {
      type: 'string',
      label: 'Заключение о качестве'
    }
  }),
  reportHaveRemarks: () => ({
    reasonDescription: {
      type: 'string',
      label: 'Требования по доработкам / Причина'
    },
    brigade: {
      type: 'brigade',
      label: 'Бригада',
      getDefaultValueFn: function () {
        const brigadesQueue = this._record.request.brigadesQueue
        if (brigadesQueue.length) {
          const lastBrigade = brigadesQueue[brigadesQueue.length - 1]
          return {
            id: lastBrigade.brigadeId,
            name: lastBrigade.brigadeGUIName || lastBrigade.brigadeName,
            workDate: lastBrigade.workDate,
            workShift: lastBrigade.workShift,
            workAreas: lastBrigade.workAreas
          }
        }
        return null
      },
      get options () {
        const assignedBrigades = this._record && this._record.request.brigadesQueue.filter(b => !b.canceled) || []
        const uniqueAssignedBrigades = []

        assignedBrigades.forEach(b => {
          if (!uniqueAssignedBrigades.find(opt => opt.brigadeId === b.brigadeId)) {
            uniqueAssignedBrigades.push(b)
          }
        })

        return uniqueAssignedBrigades.map(b => {
          return {
            id: b.brigadeId,
            name: b.brigadeGUIName || b.brigadeName,
            workDate: b.workDate,
            workShift: b.workShift,
            workAreas: b.workAreas
          }
        })
      }
    }
  }),
  driverReplacement: () => ({
    currentDriver: {
      type: 'object',
      subType: 'employee',
      subSubType: 'forkLiftDriver',
      label: 'Сменяемый водитель',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор водителя',
        getURL: function () {
          return getDriverURL(this._record.request)
        },
        select: true,
        cached: false
      },
      getDefaultValueFn: function () {
        return this._record.report.driver || null
      }
    },
    driver: {
      type: 'object',
      label: 'Прибывший водитель',
      subType: 'employee',
      subSubType: 'forkLiftDriver',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор водителя',
        getURL: function () {
          return getDriverURL(this._record.request)
        },
        select: true,
        cached: false
      }
    },
    currentAddress: {
      type: 'address',
      label: 'Адрес ТС',
      getDefaultValueFn: function () {
        return getDefaultCurrentAddress(this._record)
      }
    },
    time: {
      type: 'datetime',
      label: 'Время замены водителя (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    }
  }),
  vehicleTransfer: () => ({
    sourceBrigade: {
      type: 'brigade',
      label: 'Исходная бригада',
      getDefaultValueFn: function () {
        const assignedBrigade = this._record.request.brigades.find(brigade => brigade.assigned) || null
        if (assignedBrigade) {
          return {
            id: assignedBrigade.brigadeId,
            name: assignedBrigade.brigadeGUIName || assignedBrigade.brigadeName,
            workDate: assignedBrigade.workDate,
            workShift: assignedBrigade.workShift,
            workAreas: assignedBrigade.workAreas
          }
        } else {
          return null
        }
      }
    },
    recipientBrigade: {
      type: 'brigade',
      label: 'Принимающая бригада',
      getDefaultValueFn: function () {
        const nextAssignedBrigade = this._record.request.brigades.find(brigade => brigade.nextAssigned) || null
        if (nextAssignedBrigade) {
          return {
            id: nextAssignedBrigade.brigadeId,
            name: nextAssignedBrigade.brigadeGUIName || nextAssignedBrigade.brigadeName,
            workDate: nextAssignedBrigade.workDate,
            workShift: nextAssignedBrigade.workShift,
            workAreas: nextAssignedBrigade.workAreas
          }
        } else {
          return null
        }
      },
      get options () {
        const notAssignedBrigades = this._record && this._record.request.brigades.filter(b => !b.assigned) || []
        return notAssignedBrigades.map(b => {
          return {
            id: b.brigadeId,
            name: b.brigadeGUIName || b.brigadeName,
            workDate: b.workDate,
            workShift: b.workShift,
            workAreas: b.workAreas
          }
        })
      }
    }
  }),
  lossRelocation: () => ({
    lastAddress: {
      type: 'address',
      label: 'Последний адрес нахождения'
    },
    brigade: {
      type: 'brigade',
      label: 'Бригада',
      computed: true
    }
  }),
  lossClosure: () => ({
    brigade: {
      type: 'brigade',
      label: 'Бригада',
      computed: true
    }
  }),
  unusable: () => ({
    reasonDescription: {
      type: 'string',
      label: 'Причина'
    },
    photo: {
      label: 'Фотографии',
      type: 'documents',
      componentProps: {
        categoryKey: 'photo',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    closeRequest: {
      type: 'boolean',
      label: 'Закрыть заявку',
      getDefaultValueFn: function () {
        return this._record.bp.state === 'VP3'
      },
      onPropertyInput: function (value, object) {
        const eventId = 'acceptance'
        const acceptanceProps = this._config.props.filter(prop => prop.eventId === eventId)
        for (const prop of acceptanceProps) {
          prop._hidden = !!value
        }
      }
    }
  }),
  unusableOnAcceptance: () => ({
    vehicle: {
      type: 'object',
      label: 'Прибывшее ТС',
      subType: 'vehicle',
      subSubType: 'vehicleProvided',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор ТС',
        getURL: function () {
          return getVehiclesURL(this._record.request)
        },
        select: true,
        cached: false
      },
      getDefaultValueFn: function () {
        return this._record.request.vehicle || null
      }
    },
    driver: {
      type: 'object',
      label: 'Прибывший водитель',
      subType: 'employee',
      subSubType: 'forkLiftDriver',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        dialogLabel: 'Выбор водителя',
        getURL: function () {
          return getDriverURL(this._record.request)
        },
        select: true,
        cached: false
      },
      getDefaultValueFn: function () {
        return this._record.request.driver || null
      }
    },
    time: {
      type: 'datetime',
      label: 'Время подачи ТС (фактическое)',
      componentProps: {
        placeholder: 'Текущее время'
      }
    },
    currentAddressType: {
      type: 'listvalue',
      label: 'Адрес подачи ТС (фактический тип)',
      listvalues: [
        { value: 'agreed', name: 'Согласованный адрес' },
        { value: 'activeRequest', name: 'Активная заявка' },
        { value: 'other', name: 'Другой' }
      ]
    },
    currentAddress: {
      type: 'address',
      label: 'Адрес подачи ТС (фактический)'
    },
    reasonDescription: {
      type: 'string',
      label: 'Причина непригодности'
    },
    photo: {
      label: 'Фото, подтверждающие непригодность',
      type: 'documents',
      componentProps: {
        categoryKey: 'photo',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    closeRequest: {
      type: 'boolean',
      label: 'Закрыть заявку',
      getDefaultValueFn: function () {
        return true // == this._record.bp.state === 'VP3'
      },
      onPropertyInput: function (value, object) {
        this._config.updateProperties(object)
        // const acceptanceProps = this._config.props.filter(prop => prop.eventId === this.eventId && (prop.code === 'vehicleOdometerValue' || prop.code === 'vehicleOdometer' || prop.code === 'waybillDocuments' || prop.code === 'vehiclePerspective'))
        // for (const prop of acceptanceProps) {
        //   prop._hidden = !!value
        // }
      }
    },
    vehicleOdometerValue: {
      type: 'double',
      label: 'Показания одометра'
    },
    vehicleOdometerFaulty: {
      label: 'Одометр неисправен',
      type: 'boolean',
      onPropertyInput: function (value, object) {
        this._config.updateProperties(object)
      }
    },
    vehicleOdometer: {
      name: 'Фото одометра',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehicleOdometer',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    waybillDocuments: {
      name: 'Фото путевого листа',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'waybillDocuments',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    vehiclePerspective: {
      name: 'Фото ТС',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'vehiclePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    fencePerspective: {
      name: 'Фото выгородки',
      type: 'documents',
      componentProps: {
        // propertyKey: 'document',
        categoryKey: 'fencePerspective',
        documentType: null,
        contentType: 'image',
        readonly: false,
        expanded: true
      }
    },
    updateProperties (object) {
      const eventId = 'unusableOnAcceptance'

      const formProps = this.props.filter(prop => prop.eventId === eventId)
      const vehicleProvision = formProps[0].componentProps._record // this._record
      const request = vehicleProvision.request

      let closeRequest = false
      const closeRequestConfig = getPropertyConfig('closeRequest', eventId, this)
      if (closeRequestConfig) {
        closeRequest = object[closeRequestConfig.key]

        for (const prop of this.props) {
          if (prop.eventId === eventId) {
            if (prop.code === 'vehicleOdometer' || prop.code === 'waybillDocuments' || prop.code === 'vehiclePerspective' || prop.code === 'fencePerspective') {
              if (prop.code === 'fencePerspective' && !(request.vehicleGroupProvision && request.vehicleGroupType && request.vehicleGroupType.vehicleGroupCategory === 'fence')) {
                continue
              }
              prop._hidden = !!closeRequest
              prop.required = !closeRequest
            } else if (prop.code === 'vehicleOdometerFaulty' || prop.code === 'vehicleOdometerValue') {
              prop._hidden = !!closeRequest
            }
          }
        }
      }

      updateVehicleOdometerAcceptanceProperties(eventId, this, object)
    }
  }),
  brigade: () => ({
    brigade: {
      type: 'brigade',
      label: 'Бригада'
    }
  }),
  brigadeChange: () => ({
    brigade: {
      type: 'brigade',
      label: 'Бригада'
    },
    brigadeNameChange: {
      type: 'valueChange',
      label: 'Изменение названия'
    },
    brigadierChange: {
      type: 'valueChange',
      label: 'Изменение бригадира'
    },
    employeesChange: {
      type: 'valueChange',
      label: 'Изменение состава бригады'
    },
    workAreasChange: {
      type: 'valueChange',
      label: 'Изменение направления работ бригады'
    },
    workShiftChange: {
      type: 'valueChange',
      label: 'Изменение рабочей смены бригады'
    },
    disbanded: {
      type: 'boolean',
      label: 'Расформирована'
    },
    undisbanded: {
      type: 'boolean',
      label: 'Повторно сформирована'
    }
  }),
  copy: () => ({
    count: {
      type: 'integer',
      label: 'Количество копий',
      getDefaultValueFn: function () {
        return 1
      }
    }
  })
}

function getVehiclesURL (request) {
  const props = {}
  if (request.organization) {
    props.organization = request.organization.id
  }
  if (request.vehicleType) {
    props.vehicleType = request.vehicleType.id
  }
  return getPropertyValuesURL('vehicle', props)
}

function getDriverURL (request) {
  const props = {}
  if (request.organization) {
    props.organization = request.organization.id
  }
  return getPropertyValuesURL('driver', props)
}

function getPropertyValuesURL (propertyKey, props) {
  const params = new URLSearchParams()
  params.set('property', propertyKey)
  if (props) {
    params.set('properties', JSON.stringify(props))
  }
  return '/service/delta/vehicleProvision/propertyValues?' + params.toString()
}
